namespace $ {

	$mol_style_define( $shm_confirm_delete, {

		color: $shm_theme.error,

		Trigger: {
			color: $shm_theme.error,
		},

	} )

}
